import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * The icon of a list type: one glyph in the box of the other icons, a list
 * for a manual list and a filter for a dynamic one, named for screen readers
 * and in its tooltip.
 */
@Component({
  selector: 'app-list-type-icon',
  template: `<i
    class="fa-solid list-type-icon"
    [class.fa-filter]="type === 'dynamic'"
    [class.fa-list]="type !== 'dynamic'"
    [class.fa-lg]="large"
    role="img"
    [attr.aria-label]="label | translate"
    [title]="label | translate"
  ></i>`,
  styles: `
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 1.25em;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule],
})
export class ListTypeIconComponent {
  @Input() type: string | null = 'manual';
  /** `fa-lg`, as the icons of the tables and the sidebar. */
  @Input() large = true;

  get label() {
    return this.type === 'dynamic' ? 'lists.type.dynamic' : 'lists.type.manual';
  }
}
